 <ng-content select="[pagePrefix]"></ng-content>
 <!-- <ng-container *ngIf="menuState; else tamplatePageTile">
     <h1 class="page-title mat-h1">{{ pagetitle | translate }}</h1>
 </ng-container>
 <ng-template #tamplatePageTile> -->
    <h1 [@enterAnimation]="animate" class="page-title mat-h1" *ngIf="pageTitle">{{ pageTitle | translate }}</h1>
<!-- </ng-template>  -->
<ng-container *ngIf="pageSubtitle">
    <div [innerHTML]="pageSubtitle" class="page-subtitle" [@enterAnimation]="{value:animate ? '':'*',params:{delay:animate ? 750: 0}}"></div>
</ng-container>
<ng-content></ng-content>
